// src/utils/time.js

import { format, formatDistanceToNow } from "date-fns";

export const fDateDdMmmYyyy = (date) => {
  try {
    return format(new Date(date), "dd MMM, yyyy");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateDdMmYyyy = (date) => {
  try {
    return format(new Date(date), "dd/MM/yyyy");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateWwwDdMmmYyyy = (date) => {
  try {
    return format(new Date(date), "eee dd MMM, yyyy");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateTime24 = (date) => {
  try {
    return format(new Date(date), "dd MMM, yyyy HH:mm");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateTime12 = (date) => {
  try {
    return format(new Date(date), "dd MMM, yyyy p");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateTimeSuffix = (date) => {
  try {
    return format(new Date(date), "dd/MM/yyyy hh:mm p");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fDateTimeSuffix2 = (date) => {
  try {
    return format(new Date(date), "dd/MM/yyyy p");
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const fToNow = (date) => {
  try {
    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
    });
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const getTimeNum = (date) => {
  try {
    return date ? new Date(date).getTime() : new Date().getTime();
  } catch (err) {
    console.log(err);
    return -1;
  }
};

export const isDateExpired = (date) => {
  try {
    const now = new Date().getTime();
    const expiry = new Date(date).getTime();
    return expiry < now;
  } catch (err) {
    console.log(err);
    return false;
  }
};

export const getDateStrYyMmDd = (date) => {
  try {
    const dt = date ? new Date(date) : new Date();
    const mm = dt.getMonth() + 1;
    const dd = dt.getDate();
    const yy = dt.getFullYear();

    return `${yy}-${mm.toString().padStart(2, '0')}-${dd.toString().padStart(2, '0')}`;
  } catch (err) {
    console.log(err);
    return "Invalid";
  }
};

export const getMonthTimeRange = (date) => {
  const dt = date ? new Date(date) : new Date();

  return {
    min: new Date(dt.getFullYear(), dt.getMonth(), 1).getTime(),
    max: new Date(
      dt.getFullYear(),
      dt.getMonth() + 1,
      0,
      23,
      59,
      59,
      999
    ).getTime(),
  };
};

export const getDaysInMonth = (date) => {
  const dt = date ? new Date(date) : new Date();
  return new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();
};